import { CardActions, CardActionsProps } from "@material-ui/core";

export interface CardFooterProps extends CardActionsProps {
  ShowDivider?: boolean
}

export default function CardFooter(props: CardFooterProps) {
  const { children, ShowDivider: _ShowDivider = true, ...rest } = props
  return (
    <>

      <CardActions
        style={{ justifyContent: "space-between", marginRight: 5, marginLeft: 5 }}
        {...rest}
      >
        {children}

      </CardActions>
    </>
  );
}

